"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'PIECE TO CAMERA',
  value: 'PIECE_TO_CAMERA'
}, {
  label: 'ONE PERSON INTERVIEW',
  value: 'ONE_INTERVIEW'
}, {
  label: 'TWO PERSON INTERVIEW',
  value: 'TWO_INTERVIEW'
}, {
  label: 'TUTORIAL',
  value: 'TUTORIAL'
}, {
  label: 'EVENT',
  value: 'EVENT'
}, {
  label: 'VISUAL STORYTELLER',
  value: 'VISUAL_STORY'
}];
exports.default = _default;